import { render, staticRenderFns } from "./aiWarn.vue?vue&type=template&id=625948f4&"
import script from "./aiWarn.vue?vue&type=script&lang=js&"
export * from "./aiWarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports